const routes = {
  homePage: '/',
  contactsPage: '/Contacts',
  loginPage: '/Login',
  registerPage: '/Register',
};

export default routes;
